import confetti from 'canvas-confetti'

const DOLLAR_EMOJIS = ['💵', '💰', '🤑', '💸']

function randomInRange(min: number, max: number): number {
  return Math.random() * (max - min) + min
}

function makeDollarShape(emoji: string) {
  return confetti.shapeFromText({ text: emoji, scalar: 3 })
}

async function burst(x: number, y: number, angle: number): Promise<void> {
  const emoji = DOLLAR_EMOJIS[Math.floor(Math.random() * DOLLAR_EMOJIS.length)]!

  await confetti({
    particleCount: 20,
    angle,
    spread: 60,
    startVelocity: randomInRange(40, 65),
    origin: { x, y },
    shapes: [makeDollarShape(emoji)],
    scalar: 2,
    gravity: 0.8,
    ticks: 200,
    drift: randomInRange(-0.5, 0.5),
  })
}

export async function fireFundsReceivedConfetti(): Promise<void> {
  // Three simultaneous bursts: left, center, right
  await Promise.all([
    burst(0.15, 0.6, 60),
    burst(0.5, 0.7, 90),
    burst(0.85, 0.6, 120),
  ])

  // Second wave with plain $ signs for variety
  await new Promise<void>(resolve => setTimeout(resolve, 300))
  await Promise.all([
    confetti({
      particleCount: 30,
      angle: 75,
      spread: 80,
      startVelocity: 55,
      origin: { x: 0.3, y: 0.65 },
      shapes: [makeDollarShape('$')],
      colors: ['#22c55e', '#86efac', '#fbbf24', '#fde68a'],
      scalar: 2.5,
      ticks: 250,
    }),
    confetti({
      particleCount: 30,
      angle: 105,
      spread: 80,
      startVelocity: 55,
      origin: { x: 0.7, y: 0.65 },
      shapes: [makeDollarShape('$')],
      colors: ['#22c55e', '#86efac', '#fbbf24', '#fde68a'],
      scalar: 2.5,
      ticks: 250,
    }),
  ])
}
